import UserChatroom from "../../../components/Chatroomform";

const UpdateChatroomform=()=>{
return(<>
    <UserChatroom title="Update Chat Profile" btn="Update" />
</>)

}

export default UpdateChatroomform